/**
 * export const  HOST = 'https://77.37.45.27/quickpartyboss/';
//export const  HOST = 'http://www.letsgoparty.in/';
//export const  HOST = 'https://partyboss.in/';
//export const  HOST = 'http://localhost:8080/';
 * Axios API base URL.
 * - Local dev (`npm start`): Spring Boot defaults to port 8080 on the same host.
 * - Production build: set `REACT_APP_API_BASE_URL` (e.g. https://partyboss.in/quickpartyboss/)
 *   before `npm run build`, or fallback below runs in the browser when not localhost.
 */
export const  HOST = 'https://partyboss.in/';
//export const  HOST = 'http://localhost:8080/';
//export const HOST = 'https://77.37.45.27/quickpartyboss/';
export const  GET_THEATERS_LIST = HOST + 'searchSlots';
export const THEATRE_GALLERY_BY_NAMES = HOST + 'theatreGallery/public/by-names';
export const THEATRE_GALLERY_VIDEOS_BY_NAMES = HOST + 'theatreGallery/public/videos-by-names';
export const ADMIN_THEATRE_GALLERY_THEATERS = HOST + 'adminTheatreGallery/theaters';
export const ADMIN_THEATRE_GALLERY_IMAGES = HOST + 'adminTheatreGallery/images';
export const ADMIN_THEATRE_GALLERY_UPLOAD = HOST + 'adminTheatreGallery/upload';
export const ADMIN_THEATRE_GALLERY_SETTINGS = HOST + 'adminTheatreGallery/settings';
export const ADMIN_THEATRE_GALLERY_LEGACY = HOST + 'adminTheatreGallery/legacy';
export const ADMIN_THEATRE_GALLERY_IMPORT_LEGACY = HOST + 'adminTheatreGallery/import-legacy';
export const ADMIN_THEATRE_GALLERY_VIDEOS = HOST + 'adminTheatreGallery/videos';
export const ADMIN_THEATRE_GALLERY_UPLOAD_VIDEO = HOST + 'adminTheatreGallery/upload-video';
export const adminTheatreGallerySetVideoActive = (id) =>
  `${HOST}adminTheatreGallery/video/${id}/active`;
export const adminTheatreGalleryDeleteImage = (id) =>
  `${HOST}adminTheatreGallery/image/${id}`;
export const adminTheatreGalleryDeleteVideo = (id) =>
  `${HOST}adminTheatreGallery/video/${id}`;
export const adminTheatreGalleryDownloadImage = (id) =>
  `${HOST}adminTheatreGallery/image/${id}/download`;
export const adminTheatreGalleryDownloadVideo = (id) =>
  `${HOST}adminTheatreGallery/video/${id}/download`;
export const adminTheatreGallerySetActive = (id) =>
  `${HOST}adminTheatreGallery/image/${id}/active`;

export const ADMIN_THEATRE_GALLERY_NOTE = `${HOST}adminTheatreGallery/theater-note`;
export const ADMIN_THEATRE_GALLERY_EXPERIENCE_HIGHLIGHTS = `${HOST}adminTheatreGallery/theater-experience-highlights`;
/** POST { names: string[] } → { [THEATER_KEY]: { lines: { icon, text }[] } } */
export const THEATRE_EXPERIENCE_HIGHLIGHTS_BY_NAMES =
  `${HOST}theatreGallery/public/experience-highlights-by-names`;

/** Public CMS snapshot (pretty JSON merged with UI defaults client-side). */
export const PUBLIC_SITE_CMS_URL = HOST + "public/siteCms";
/** SUPER_ADMIN: persists merged CMS payload to backend {@code partyboss.site-cms.file}. */
export const ADMIN_SITE_CMS_URL = HOST + "admin/siteCms";

export const ADMIN_SITE_PAGE_MEDIA_UPLOAD = HOST + "adminSitePageMedia/upload";
/** Multipart POST field name: {@code file} — response JSON {@code { url: "/media/site-page-video/..." }} */
export const ADMIN_SITE_PAGE_MEDIA_UPLOAD_VIDEO =
  HOST + "adminSitePageMedia/upload-video";
export const  GET_THEATERA_BY_DATE = 'https://dummyjson.com/products/1';
export const  GET_META_DATA_ADDONS = HOST + 'fetchMeta';
// export const  BOOK_EVENT = HOST + 'bookEvent';
export const GET_ALL_EVENTS = HOST + 'findEvents';
export const GET_ALL_UPCOMING_EVENTS = HOST + 'findUpcomingEvents';
export const ADMIN_ADD_UPDATE_TIMESLOT = HOST + 'addUpdateTimeslot';
export const ADMIN_ADD_UPDATE_EVENTTYPE = HOST + 'addUpdateEventType';
export const ADMIN_ADD_UPDATE_ADDONS = HOST + 'addUpdateAddons';
export const ADMIN_ADD_UPDATE_THEATRE = HOST + 'addUpdateTheatre';
export const ADMIN_ADD_UPDATE_SLOT_TIME_OFFER = HOST + 'addUpdateSlotTimeOffer';
export const ADMIN_DELETE_SLOT_TIME_OFFER = HOST + 'deleteSlotTimeOffer';
export const ADMIN_LOGIN_VALIDATE = HOST + 'validateAdmin';
export const BOOK_VIA_CALL = HOST + 'bookViaCall';
export const GET_EVENT_BY_BOOK_REF_ID = HOST + 'findEventByBookRefId';
export const  BOOK_NOW_AND_PAY_LATER = HOST + 'bookNowPayLater';
export const  UPDATE_EVENT_DETAILS = HOST + 'updateEvent';
export const  CANCEL_EVENT = HOST + 'cancelEvent';
export const  BOOK_NOW_AND_PAY = HOST + 'newbookNowAndPay';
export const  UPDATE_PD = HOST + 'updatePd';
export const MARK_PAYMENT_ABANDONED = HOST + 'markPaymentAbandoned';
export const RESUME_BOOKING_PAYMENT = HOST + 'resumeBookingPayment';
export const FIND_FAILED_ONLINE_PAYMENTS = HOST + 'findFailedOnlinePayments';

// ---- Promo codes -----------------------------------------------------------
/** Public: returns the active popup-default promo code (204 when none configured). */
export const PROMO_POPUP_ACTIVE = HOST + 'promo/active/popup';
/** Public: capture lead from welcome popup; reveals code or "alreadyRedeemed" state. */
export const PROMO_POPUP_LEAD = HOST + 'promo/popup/lead';
/** Public: validate {code, phoneNumber, bookingAmount} at checkout. */
export const PROMO_VALIDATE = HOST + 'promo/validate';

/** Admin (SUPER_ADMIN only) — pass {@code X-Admin-Role: SUPER_ADMIN} header. */
export const ADMIN_PROMO_CODES = HOST + 'admin/promoCodes';
export const adminPromoCodeUrl = (id) => `${HOST}admin/promoCodes/${id}`;
export const adminPromoCodeActiveUrl = (id) => `${HOST}admin/promoCodes/${id}/active`;
export const adminPromoCodeUsageUrl = (id) => `${HOST}admin/promoCodes/${id}/usage`;
/** SUPER_ADMIN: bookings that consumed a date-range slot-time offer (package-base savings). */
export const ADMIN_PROMO_CODES_SLOT_TIME_OFFER_BOOKINGS =
  `${HOST}admin/promoCodes/slot-time-offer-bookings`;
/** SUPER_ADMIN: booking analytics (?granularity=daily|monthly|quarterly|halfyearly & optional ?tableMonths=6–60 for calendar-month tables). */
export const ADMIN_BOOKING_ANALYTICS = `${HOST}admin/analytics/bookings`;

/** Matches Spring Boot {@code X-Booking-Analytics-Token} after OTP verification. */
export const ANALYTICS_SESSION_HEADER = "X-Booking-Analytics-Token";
/** SUPER_ADMIN: whitelist emails eligible for analytics OTP (+ login counts per email). */
export const ADMIN_BOOKING_ANALYTICS_ACCESS_EMAILS = `${HOST}admin/analytics/access/emails`;
export const ADMIN_BOOKING_ANALYTICS_OTP_CONTEXT = `${HOST}admin/analytics/access/otp/context`;
export const ADMIN_BOOKING_ANALYTICS_OTP_SEND = `${HOST}admin/analytics/access/otp/send`;
export const ADMIN_BOOKING_ANALYTICS_OTP_VERIFY = `${HOST}admin/analytics/access/otp/verify`;

/** SUPER_ADMIN + analytics OTP token: banquet import, grocery-style daily expenses, fixed monthly ledger, consolidated profit. */
export const ADMIN_FINANCE_PROFIT_SUMMARY = `${HOST}admin/analytics/finance/profit-summary`;
export const ADMIN_FINANCE_EXECUTIVE_SUMMARY = `${HOST}admin/analytics/finance/executive-summary`;
export const ADMIN_FINANCE_CASHFLOW_CHART = `${HOST}admin/analytics/finance/cashflow-chart`;
export const ADMIN_FINANCE_MONTHLY_OVERVIEW = `${HOST}admin/analytics/finance/monthly-overview`;
export const ADMIN_FINANCE_MONTHLY_COMPARISON = `${HOST}admin/analytics/finance/monthly-comparison`;
export const ADMIN_FINANCE_BANQUET_UPLOAD = `${HOST}admin/analytics/finance/banquet/upload`;
export const ADMIN_FINANCE_BANQUET_MONTHLY = `${HOST}admin/analytics/finance/banquet/monthly`;
/** GET ?calendarMonth=yyyy-MM — line-level rows (import + admin) for finance grid. */
export const ADMIN_FINANCE_BANQUET_BOOKING_LINES = `${HOST}admin/analytics/finance/banquet/booking-lines`;
export const adminFinanceBanquetBookingPutUrl = (id) =>
  `${HOST}admin/analytics/finance/banquet/bookings/${encodeURIComponent(id)}`;
/** ADMIN + SUPER_ADMIN — no analytics OTP */
export const ADMIN_BANQUET_BOOKINGS_BASE = `${HOST}admin/banquet/bookings`;
export const adminBanquetBookingPutUrl = (id) =>
  `${ADMIN_BANQUET_BOOKINGS_BASE}/${encodeURIComponent(id)}`;
export const adminBanquetBookingSendConfirmationUrl = (id) =>
  `${ADMIN_BANQUET_BOOKINGS_BASE}/${encodeURIComponent(id)}/send-confirmation`;
export const adminBanquetBookingCancelUrl = (id) =>
  `${ADMIN_BANQUET_BOOKINGS_BASE}/${encodeURIComponent(id)}/cancel`;
export const adminBanquetBookingPostponeUrl = (id) =>
  `${ADMIN_BANQUET_BOOKINGS_BASE}/${encodeURIComponent(id)}/postpone`;
export const ADMIN_FINANCE_EXPENSE_PRESETS = `${HOST}admin/analytics/finance/expense-presets/categories`;
export const ADMIN_FINANCE_DAILY_EXPENSES = `${HOST}admin/analytics/finance/daily-expenses`;
export const adminFinanceDailyExpenseDelete = (id) => `${HOST}admin/analytics/finance/daily-expenses/${encodeURIComponent(id)}`;
export const ADMIN_FINANCE_MONTHLY_FIXED = `${HOST}admin/analytics/finance/monthly-fixed`;
export const adminFinanceMonthlyFixedUpsert = (periodKey) =>
  `${HOST}admin/analytics/finance/monthly-fixed/${encodeURIComponent(periodKey)}`;

// ---- Expense uploads (SUPER_ADMIN + analytics OTP) ----
/** POST multipart 'file' — bank can be 'icici' or 'idfc'. */
export const adminFinanceUploadBankUrl = (bank) =>
  `${HOST}admin/analytics/finance/uploads/bank/${encodeURIComponent(String(bank || "").toLowerCase())}`;
export const ADMIN_FINANCE_UPLOAD_PETPOOJA_DAYEND =
  `${HOST}admin/analytics/finance/uploads/petpooja/dayend`;
export const ADMIN_FINANCE_UPLOAD_PETPOOJA_ORDERS =
  `${HOST}admin/analytics/finance/uploads/petpooja/orders`;
export const ADMIN_FINANCE_UPLOAD_EMP_SALARY =
  `${HOST}admin/analytics/finance/uploads/emp-salary`;
export const ADMIN_FINANCE_GMAIL_HYPER_POLL =
  `${HOST}admin/analytics/finance/gmail/hyper/poll`;
export const ADMIN_FINANCE_GMAIL_HYPER_STATUS =
  `${HOST}admin/analytics/finance/gmail/hyper/status`;
export const adminFinanceGmailHyperPollUrl = (lookbackMonths, force = false) => {
  const p = new URLSearchParams();
  if (lookbackMonths != null && lookbackMonths !== "") p.set("lookbackMonths", String(lookbackMonths));
  if (force) p.set("force", "true");
  const q = p.toString();
  return q ? `${ADMIN_FINANCE_GMAIL_HYPER_POLL}?${q}` : ADMIN_FINANCE_GMAIL_HYPER_POLL;
};
export const ADMIN_FINANCE_GMAIL_HYPER_RESET =
  `${HOST}admin/analytics/finance/gmail/hyper/reset-cursor`;

// ---- Bank reconciliation ----
/** GET ?bank=ICICI|IDFC&fromDate&toDate */
export const ADMIN_FINANCE_BANK_LEDGER = `${HOST}admin/analytics/finance/bank/ledger`;
/** POST ?fromDate&toDate */
export const ADMIN_FINANCE_RECONCILIATION_RUN =
  `${HOST}admin/analytics/finance/reconciliation/run`;
export const ADMIN_FINANCE_RECONCILIATION_RULES =
  `${HOST}admin/analytics/finance/reconciliation/rules`;
export const adminFinanceReconciliationRuleDelete = (id) =>
  `${HOST}admin/analytics/finance/reconciliation/rules/${encodeURIComponent(id)}`;
export const adminFinanceBankLedgerCategoryUrl = (id) =>
  `${HOST}admin/analytics/finance/bank/ledger/${encodeURIComponent(id)}/category`;

// ---- Stock report ----
export const ADMIN_FINANCE_STOCK_MONTHLY = `${HOST}admin/analytics/finance/stock/monthly`;
export const ADMIN_FINANCE_STOCK_DRILLDOWN = `${HOST}admin/analytics/finance/stock/drilldown`;

// ---- Vendor income (Swiggy / Zomato / EasyDiner from bank statement) ----
/** GET ?fromDate&toDate */
export const ADMIN_FINANCE_BANK_VENDOR_INCOME =
  `${HOST}admin/analytics/finance/bank/vendor-income`;

// ---- Petpooja day-end vs ICICI settlement ----
/** GET ?fromDate&toDate */
export const ADMIN_FINANCE_PETPOOJA_DAYEND_VS_ICICI =
  `${HOST}admin/analytics/finance/petpooja/dayend-vs-icici`;

// ---- Petpooja monthly summary (Dine-In / Delivery / Zomato / Swiggy / EasyDiner) ----
export const ADMIN_FINANCE_PETPOOJA_MONTHLY =
  `${HOST}admin/analytics/finance/petpooja/monthly`;

// ---- Employee salary monthly view ----
export const ADMIN_FINANCE_EMP_SALARY_MONTHS =
  `${HOST}admin/analytics/finance/emp-salary/months`;
export const ADMIN_FINANCE_EMP_SALARY = `${HOST}admin/analytics/finance/emp-salary`;
export const ADMIN_FINANCE_EMP_SALARY_ADVANCE =
  `${HOST}admin/analytics/finance/emp-salary/advance-summary`;
export const ADMIN_FINANCE_EMP_SALARY_ADVANCE_ENTRY =
  `${HOST}admin/analytics/finance/emp-salary/advance-entry`;
export const ADMIN_FINANCE_PARTNER_SHARE = `${HOST}admin/analytics/finance/partner-share`;
export const ADMIN_FINANCE_PARTNER_SHARE_SETTINGS = `${HOST}admin/analytics/finance/partner-share/settings`;
export const ADMIN_FINANCE_HYPER_KITCHEN_COMPARE = `${HOST}admin/analytics/finance/hyper/kitchen-compare`;

// ---- Hyper Gmail item aggregate ----
/** GET ?periodKey=yyyy-MM */
export const ADMIN_FINANCE_HYPER_ITEMS = `${HOST}admin/analytics/finance/hyper/items`;
/** GET ?periodKey=yyyy-MM — one row per Hyper order (sourceRef) */
export const ADMIN_FINANCE_HYPER_ORDERS = `${HOST}admin/analytics/finance/hyper/orders`;
/** GET ?orderRef=… — line items for a Hyper order */
export const ADMIN_FINANCE_HYPER_ORDER_LINES = `${HOST}admin/analytics/finance/hyper/order-lines`;

export const ADMIN_FINANCE_UPLOAD_WHATSAPP_PLASTIC =
  `${HOST}admin/analytics/finance/uploads/whatsapp/plastic`;
export const ADMIN_FINANCE_PLASTIC_LEDGER = `${HOST}admin/analytics/finance/plastic/ledger`;
export const ADMIN_FINANCE_PLASTIC_SETTINGS = `${HOST}admin/analytics/finance/plastic/settings`;
export const ADMIN_FINANCE_PLASTIC_RESET = `${HOST}admin/analytics/finance/plastic/reset`;
export const adminFinanceUploadWhatsAppPlasticUrl = (replaceAll = false) =>
  `${HOST}admin/analytics/finance/uploads/whatsapp/plastic?replaceAll=${replaceAll ? "true" : "false"}`;

/** GET ?periodKey=yyyy-MM — coal | dairy */
export const adminFinanceVendorPayableLedgerUrl = (vendorId, periodKey) => {
  const q = periodKey ? `?periodKey=${encodeURIComponent(periodKey)}` : "";
  return `${HOST}admin/analytics/finance/vendor-payable/${encodeURIComponent(vendorId)}/ledger${q}`;
};
export const adminFinanceVendorPayableSettingsUrl = (vendorId) =>
  `${HOST}admin/analytics/finance/vendor-payable/${encodeURIComponent(vendorId)}/settings`;
/** GET ?periodKey=yyyy-MM — all vendor debts */
export const adminFinanceVendorDebtsUrl = (periodKey) => {
  const q = periodKey ? `?periodKey=${encodeURIComponent(periodKey)}` : "";
  return `${HOST}admin/analytics/finance/vendor-debts${q}`;
};
/** GET/PUT ?periodKey=yyyy-MM — per-module cash amounts + monthly total */
export const adminFinanceMonthlyCashUrl = (periodKey) =>
  `${HOST}admin/analytics/finance/monthly-cash?periodKey=${encodeURIComponent(periodKey)}`;
/** POST ?periodKey= — add one cash payment line */
export const adminFinanceMonthlyCashAddLineUrl = (periodKey) =>
  `${HOST}admin/analytics/finance/monthly-cash/lines?periodKey=${encodeURIComponent(periodKey)}`;
/** DELETE ?periodKey=&slotId= — remove cash payment line */
export const adminFinanceMonthlyCashDeleteLineUrl = (periodKey, slotId, lineId) =>
  `${HOST}admin/analytics/finance/monthly-cash/lines/${encodeURIComponent(lineId)}?periodKey=${encodeURIComponent(periodKey)}&slotId=${encodeURIComponent(slotId)}`;
/** GET/POST ?periodKey= — cash income (Partyboss / Banquet / Restaurant) */
export const adminFinanceCashIncomeUrl = (periodKey) =>
  `${HOST}admin/analytics/finance/cash-income?periodKey=${encodeURIComponent(periodKey)}`;
/** POST ?periodKey= — add cash income line */
export const adminFinanceCashIncomeAddLineUrl = (periodKey) =>
  `${HOST}admin/analytics/finance/cash-income/lines?periodKey=${encodeURIComponent(periodKey)}`;
/** DELETE ?periodKey=&source= — remove cash income line */
export const adminFinanceCashIncomeDeleteLineUrl = (periodKey, source, lineId) =>
  `${HOST}admin/analytics/finance/cash-income/lines/${encodeURIComponent(lineId)}?periodKey=${encodeURIComponent(periodKey)}&source=${encodeURIComponent(source)}`;

// ---- Site settings (welcome flash on/off) ---------------------------------
/** Public read of the welcome-flash toggle. */
export const SITE_WELCOME_FLASH = HOST + 'site/settings/welcomeFlash';
/** Admin write of the welcome-flash toggle (SUPER_ADMIN only). */
export const ADMIN_WELCOME_FLASH = HOST + 'admin/settings/welcomeFlash';

/** Full-site SPA maintenance gate (public read). */
export const SITE_MAINTENANCE_MODE = HOST + 'site/settings/maintenanceMode';
/** Admin write maintenance gate (SUPER_ADMIN only). */
export const ADMIN_MAINTENANCE_MODE = HOST + 'admin/settings/maintenanceMode';

// ---- My Booking (public self-serve add-ons) -------------------------------
/** Public: GET ?phoneNumber=XXXXXXXXXX → MyBookingLookupResponse with status + summary. */
export const MY_BOOKING_LOOKUP = HOST + 'myBooking/lookup';
/** Public: POST { bookingReferenceId, phoneNumber, nameOnCake?, newAddons[] } → updated summary + new email. */
export const MY_BOOKING_ADD_ADDONS = HOST + 'myBooking/addAddons';

// ---- Customer leads (admin call queue) ------------------------------------
/** Admin (SUPER_ADMIN) — list captured leads, optional ?status=NEW|CONTACTED|... */
export const ADMIN_CUSTOMER_LEADS = HOST + 'admin/customerLeads';
/** Admin (SUPER_ADMIN) — PATCH lead status/notes. */
export const adminCustomerLeadUrl = (id) => `${HOST}admin/customerLeads/${id}`;

// ---- Marketing / QR / attribution (SUPER_ADMIN) -------------------------
export const ADMIN_BOOKING_FOLLOWUP_SETTINGS = HOST + 'admin/marketing/booking-followup-settings';
/** GET → JSON array { id, name, scanTargetUrl } for active theatres */
export const ADMIN_MARKETING_THEATRES_POSTER = HOST + 'admin/marketing/theatres-for-posters';
/** SUPER_ADMIN: colour gradient PNG for venue entry posters. variant=BOOK_NOW | THEATRE */
export const adminMarketingColorEntryQrUrl = (variant, theatreId) => {
  const p = new URLSearchParams({ variant: String(variant || "").toUpperCase() });
  if (theatreId != null && theatreId !== "") p.set("theatreId", String(theatreId));
  return `${HOST}admin/marketing/entry-qr.png?${p.toString()}`;
};
/** GET → JSON array { sourceTag, bookingCount } */
export const ADMIN_BOOKING_SOURCES_STATS = HOST + 'admin/booking-sources/stats';
export const QR_MY_BOOKING_PNG = HOST + 'public/qr/my-booking.png';
export const qrTheatreQuickBookPngUrl = (theatreId, src = 'qr_theatre') =>
  `${HOST}public/qr/quick-book/theatre/${encodeURIComponent(theatreId)}.png?src=${encodeURIComponent(src)}`;

// ---- Local test-mode helpers ---------------------------------------------
/**
 * True when the React app is running on a developer/QA box (localhost/127.0.0.1).
 * Used by the booking flow to bypass Razorpay (the backend recognises the
 * resulting "TEST-" payment id and skips admin email notifications).
 */
export const IS_LOCAL_TEST_MODE = (() => {
  try {
    if (typeof window === 'undefined' || !window.location) return false;
    const host = (window.location.hostname || '').toLowerCase();
    return host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0' || host.endsWith('.local');
  } catch (e) {
    return false;
  }
})();

/** Build a fake Razorpay-style response so we can hit /updatePd in test mode. */
export const buildTestPaymentResponse = (orderId) => ({
  orderId: orderId || `TEST-ORDER-${Date.now()}`,
  paymentId: `TEST-PAYMENT-${Date.now()}`,
  signature: 'TEST-SIGNATURE',
  status: 'SUCCESS',
  source: 'LOCALHOST_TEST_MODE',
});